import { render } from "./linchuang-news.vue?vue&type=template&id=30a2d8ea&scoped=true"
import script from "./linchuang-news.vue?vue&type=script&lang=js"
export * from "./linchuang-news.vue?vue&type=script&lang=js"

import "./linchuang-news.vue?vue&type=style&index=0&id=30a2d8ea&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30a2d8ea"]])

export default __exports__